var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "embroidery-main-view-preview small-centered text-center"
  }, [_c('div', {
    attrs: {
      "id": "snapshot-image-scene"
    }
  }), _c('base-spinner'), _c('div', {
    staticClass: "row"
  }, _vm._l(_vm.images, function (item, index) {
    return _c('div', {
      key: item.caption,
      class: [{
        'columns small-6': _vm.itemsToPersonalize > 1
      }]
    }, [_c('div', {
      class: ['embroidery-main-view-preview-crop-image', {
        'side-model': _vm.isSideModel && !_vm.isUGCApplied
      }, {
        'tall-model': _vm.isTallModel
      }, {
        'ugc-applied': _vm.isUGCApplied && !_vm.isSideModel
      }, {
        'side-model-ugc': _vm.isUGCApplied && _vm.isSideModel
      }, {
        'embroidery-main-view-preview-first-image': index === 0 && _vm.itemsToPersonalize > 1
      }, {
        'embroidery-main-view-preview-single-image small-centered': _vm.itemsToPersonalize === 1
      }]
    }, [_c('img', {
      class: ['embroidery-main-view-preview-crop-image-img', {
        'side-model': _vm.isSideModel && !_vm.isUGCApplied
      }, {
        'tall-model': _vm.isTallModel
      }, {
        'ugc-applied': _vm.isUGCApplied && !_vm.isSideModel
      }, {
        'side-model-ugc': _vm.isUGCApplied && _vm.isSideModel
      }],
      attrs: {
        "src": item.imgSrc,
        "alt": "".concat(_vm.pdm.product_name, " ").concat(item.caption)
      },
      on: {
        "load": _vm.imageIsLoaded
      }
    })])]);
  }), 0)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }